export default __webpack_public_path__ + "static/media/Space Oddity.73f4ebc0.mp3";